import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/config/company";

/**
 * WebSite schema with SearchAction for Google Sitelinks Searchbox.
 * Enables direct search from Google search results.
 */
export function WebSiteJsonLd() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${COMPANY.website}/#website`,
    name: COMPANY.name,
    url: COMPANY.website,
    description:
      "TrustedHeal is India's leading medical tourism platform connecting international patients with JCI-accredited hospitals for affordable, world-class medical treatment.",
    publisher: {
      "@id": `${COMPANY.website}/#organization`,
    },
    inLanguage: "en-US",
    potentialAction: [
      {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${COMPANY.website}/treatments?search={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    </Helmet>
  );
}
